<!-- <h1 mat-dialog-title>{{ getTitle() }}</h1> -->
<div class="dialog-header">
  <h1 mat-dialog-title>{{ getTitle() }}</h1>
  <button mat-icon-button (click)="closeDialog()" class="close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>
<br>
<div class="dialog-content">
  <div class="form-section">
    <div style="display: flex;">

      <div style="width: 30%; margin-right: 65px;">
        <mat-form-field>
          <mat-label>Select Voucher Type<span style="color: red">*</span></mat-label>
           <mat-select [(ngModel)]="voucherType" #dataRef
            (ngModelChange)="showinterbranchdesign();showpurchesvoucherdesign();fetchvouchertype(dataRef.value);showdesigns()"
            placeholder="Select Voucher Type" [disabled]="isUpdate">
            <mat-option *ngFor="let item of vouchers" [value]="item.id">{{ item.name }}</mat-option>
          </mat-select> 
          <!-- <mat-select [(ngModel)]="voucherType"
  (ngModelChange)="onVoucherTypeChange($event)"
  placeholder="Select Voucher Type" [disabled]="isUpdate">
  <mat-option *ngFor="let item of vouchers" [value]="item.id">{{ item.name }}</mat-option>
  </mat-select> -->
        </mat-form-field>
      </div>
      <div style="width: 30%; margin-right: 65px;"
        *ngIf="this.voucher_type == 'Credit Note'|| this.voucher_type == 'Debit Note'">
        <mat-form-field>
          <mat-label>Select invoice type<span style="color: red">*</span></mat-label>
          <mat-select [(ngModel)]="invoice_type" placeholder="Select invoice type" [disabled]="isUpdate || isView">
            <mat-option value="sales" *ngIf="voucher_type == 'Credit Note'">Sales Voucher</mat-option>
            <mat-option value="purchase" *ngIf="voucher_type == 'Debit Note'">Purchase Voucher</mat-option>
            <mat-option value="credit note" *ngIf="voucher_type == 'Debit Note'">Credit Note Voucher</mat-option>
            <mat-option value="debit note" *ngIf="voucher_type == 'Credit Note'">Debit Note Voucher</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div style="width: 30%; margin-right: 65px;" *ngIf="!voucher_type || this.voucher_type == 'Purchase' || this.voucher_type == 'Sales' || this.voucher_type == 'Receipt Voucher'|| this.voucher_type == 'Credit Note'|| this.voucher_type == 'Debit Note'">
        <mat-form-field>
          <mat-label>Select Branch<span style="color: red">*</span></mat-label>
          <mat-select [(ngModel)]="branch" #branch_id (ngModelChange)="onBranchChangeWithLedger(branch_id.value)" placeholder="Select Branch" [disabled]="isUpdate|| isView">
            <mat-option *ngFor="let type of branchdata" [value]="type.id">{{ type.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <!-- <div style="width: 30%; margin-right: 150px;" *ngIf="this.voucher_type !== 'Inter Branch' && this.voucher_type !== 'Advance Multibranch'&& voucher_type !== 'Inventory Voucher' && this.voucher_type !== 'Purchase' && this.voucher_type !== 'Sales' && this.voucher_type !== 'Credit Note'&& this.voucher_type !== 'Debit Note'">
        <mat-form-field>
          <mat-label>Select Profit Cost</mat-label>
          <mat-select [(ngModel)]="profit_cost_id" placeholder="Select Profit Cost" (ngModelChange)="onProfitCost($event)"
            [disabled]="isUpdate">
            <mat-option value="">Select Profit Cost</mat-option>
            <mat-option *ngFor="let profitcost of profit_cost" [value]="profitcost.id">
              {{ profitcost.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div style="width: 30%; margin-right: 150px;"
        *ngIf="!showPurches && voucher_type !== 'Inventory Voucher' && this.voucher_type !== 'Credit Note' && this.voucher_type !== 'Debit Note' && this.voucher_type !== 'Inter Branch' && this.voucher_type !== 'Advance Multibranch'">
        <mat-form-field>
          <mat-label>Select Section</mat-label>
          <mat-select [(ngModel)]="section_id" placeholder="Select Section" [disabled]="isUpdate">
            <mat-option *ngFor="let item of filteredSections" [value]="item.id">{{ item.section_name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div style="width: 30%; margin-right: 150px;"
        *ngIf="!showPurches && voucher_type !== 'Inventory Voucher' && this.voucher_type !== 'Credit Note' && this.voucher_type !== 'Debit Note' && this.voucher_type !== 'Inter Branch' && this.voucher_type !== 'Advance Multibranch'">
        <mat-form-field>
          <mat-label>Select Store</mat-label>
          <mat-select [(ngModel)]="store_id" placeholder="Select Store"
            [disabled]="isUpdate">
            <mat-option *ngFor="let item of store_data" [value]="item.id">{{ item.store_name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div> -->

        <div style="width: 30%; margin-right: 65px;"*ngIf="!showPurches && voucher_type !== 'Inventory Voucher' && this.voucher_type !== 'Credit Note' && this.voucher_type !== 'Debit Note' && this.voucher_type !== 'Inter Branch' && this.voucher_type !== 'Advance Multibranch'">
        <mat-form-field>
           <mat-label>Select Employee ID</mat-label>
           <mat-select [(ngModel)]="selectedEmployees" multiple (ngModelChange)="onEmployeeHeaderChange()">
            <mat-option *ngFor="let emp of employee_data" [value]="emp.id">
           {{ emp.papl_id }}
         </mat-option>
        </mat-select>
     </mat-form-field>
    </div>

     <div style="width: 30%; margin-right: 65px;" *ngIf="!showPurches && voucher_type !== 'Inventory Voucher' && this.voucher_type !== 'Credit Note' && this.voucher_type !== 'Debit Note' && this.voucher_type !== 'Inter Branch' && this.voucher_type !== 'Advance Multibranch'">
     <mat-form-field>
       <mat-label>Select Employee Name</mat-label>
       <mat-select [(ngModel)]="selectedEmployees" multiple (ngModelChange)="onEmployeeHeaderChange()">
         <mat-option *ngFor="let emp of employee_data" [value]="emp.id">
         {{ emp.adhar_name }}
      </mat-option>
     </mat-select>
     </mat-form-field>
   </div>

      <div style="width: 30%; margin-right: 50px;" *ngIf="this.invoice_type == 'purchase'">
        <mat-form-field>
          <mat-label>Select Purchase Invoice<span style="color: red">*</span></mat-label>
          <mat-select [(ngModel)]="purchaseInvoice" #pidata placeholder="Select Purchase Invoice"
            (ngModelChange)="fetchProfitCostFromInvoice(this.invoice_type,purchaseInvoice)" [disabled]="isUpdate || isView">
            <mat-option *ngFor="let item of purchase_invoice" [value]="item.id">{{ item.voucher_no }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      
      <div style="width: 30%; margin-right: 50px;" *ngIf="this.invoice_type == 'sales'">
        <mat-form-field>
          <mat-label>Select Sales Invoice<span style="color: red">*</span></mat-label>
          <mat-select [(ngModel)]="salesInvoice" placeholder="Select Sales Invoice"
            (ngModelChange)="fetchProfitCostFromInvoice(this.invoice_type,salesInvoice)" [disabled]="isUpdate || isView">
            <mat-option *ngFor="let item of sales_invoice" [value]="item.id">{{ item.voucher_no }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div style="width: 30%; margin-right: 50px;" *ngIf="this.invoice_type == 'credit note'">
        <mat-form-field>
          <mat-label>Select Credit Note<span style="color: red">*</span></mat-label>
          <mat-select [(ngModel)]="creditNote" placeholder="Select Credit Note"
            (ngModelChange)="fetchProfitCostFromInvoice(this.invoice_type,creditNote)" [disabled]="isUpdate || isView">
            <mat-option *ngFor="let item of credit_note" [value]="item.id">{{ item.voucher_no }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      
      <div style="width: 30%; margin-right: 50px;" *ngIf="this.invoice_type == 'debit note'">
        <mat-form-field>
          <mat-label>Select Debit Note<span style="color: red">*</span></mat-label>
          <mat-select [(ngModel)]="debitNote" placeholder="Select Debit Note"
            (ngModelChange)="fetchProfitCostFromInvoice(this.invoice_type,debitNote)" [disabled]="isUpdate || isView">
            <mat-option *ngFor="let item of debit_note" [value]="item.id">{{ item.voucher_no }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div style="width: 30%; margin-right: 65px;" *ngIf="this.voucher_type == 'Purchase' || this.voucher_type == 'Sales'|| this.voucher_type == 'Credit Note'|| this.voucher_type == 'Debit Note'">
        <mat-form-field>
          <mat-label>Select Profit Cost<span style="color: red">*</span></mat-label>
          <mat-select [(ngModel)]="profit_cost_id" placeholder="Select Profit Cost"(ngModelChange)="onProfitCost($event)"
           [disabled]="isUpdate || isView" multiple>
            <!-- <mat-option value="">Select Profit Cost</mat-option> -->
            <mat-option *ngFor="let profitcost of profit_cost" [value]="profitcost.id">
              {{ profitcost.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div style="width: 20%; margin-right: 50px;" *ngIf="this.invoice_type == 'credit note' || this.invoice_type == 'sales'">
        <mat-form-field class="custom-datepicker">
          <mat-label>Customer Name</mat-label>
          <input type="customer" matInput [(ngModel)]="customers" placeholder="customer" class="custom-input" [disabled]="invoice_type || isView">
        </mat-form-field>
      </div>
      <div style="width: 20%; margin-right: 50px;" *ngIf="this.invoice_type == 'credit note' || this.invoice_type == 'sales'">
        <mat-form-field class="custom-datepicker">
          <mat-label>Customer Branch</mat-label>
          <input type="cutomer_branch" matInput [(ngModel)]="cutomer_branchs" placeholder="Customer Branch"
            class="custom-input" [disabled]="invoice_type || isView">
        </mat-form-field>
      </div>
      
      <div style="width: 20%; margin-right: 50px;"
        *ngIf="this.invoice_type == 'debit note' || this.invoice_type == 'purchase'">
        <mat-form-field class="custom-datepicker">
          <mat-label>Vendor Name</mat-label>
          <input type="vendor" matInput [(ngModel)]="vendors" placeholder="vendor" class="custom-input" [disabled]="invoice_type || isView">
        </mat-form-field>
      </div>
      <div style="width: 20%; margin-right: 50px;"
        *ngIf="this.invoice_type == 'debit note' || this.invoice_type == 'purchase'">
        <mat-form-field class="custom-datepicker">
          <mat-label>Vendor Branch</mat-label>
          <input type="vendor_branch" matInput [(ngModel)]="vendor_branchs" placeholder="Vendor Branch" class="custom-input" [disabled]="invoice_type || isView">
        </mat-form-field>
      </div>
      
      <div style="width: 20%; margin-right: 50px;" *ngIf="this.invoice_type == 'purchase' || this.invoice_type == 'sales'">
        <label style="font-weight: 600; font-size: 14px; margin-bottom: 5px; display: block;">
          Select Type
        </label>
        <mat-radio-group aria-label="Select an Type" style="display: flex; gap: 20px; align-items: center;"
          [(ngModel)]="type" [disabled]="isView">
          <mat-radio-button class="value" [value]="1">Value</mat-radio-button>
          <mat-radio-button class="qty" [value]="2">Quantity</mat-radio-button>
        </mat-radio-group>
      </div>
      
      <div style="width: 20%; margin-right: 50px;" *ngIf="this.invoice_type == 'purchase'&& this.type == 1">
        <label style="font-weight: 600; font-size: 14px; margin-bottom: 5px; display: block;">
          Affect Qty?
        </label>
        <mat-radio-group aria-label="Select an Type" style="display: flex; gap: 20px; align-items: center;"
          [(ngModel)]="affect_qty" (ngModelChange)="affectQty($event)" [disabled]="isView">
          <mat-radio-button class="value" [value]="1">Yes</mat-radio-button>
          <mat-radio-button class="qty" [value]="0">No</mat-radio-button>
        </mat-radio-group>
      </div>

      <div style="width: 20%; margin-right: 50px;" *ngIf="this.invoice_type">
        <mat-form-field class="custom-datepicker">
          <mat-label>Invoice Date</mat-label>
          <input type="date" matInput [(ngModel)]="invoice_date" placeholder="DD/MM/YYYY" class="custom-input" [max]="maxDate"
           [disabled]="invoice_type || isView">
        </mat-form-field>
      </div>
      <!-- <div style="width: 30%; margin-right: 200px;">
        <mat-form-field>
          <mat-label>Voucher Sl.No</mat-label>
          <input matInput type="text" [(ngModel)]="voucherNo" placeholder="Voucher Sl.No" disabled>
        </mat-form-field>
      </div> -->
      <div style="width: 20%; margin-right: 50px;">
        <mat-form-field class="custom-datepicker">
          <mat-label>Posting Date<span style="color: red">*</span></mat-label>
          <input type="date" matInput [(ngModel)]="date" placeholder="DD/MM/YYYY" class="custom-input" [attr.min]="invoice_date || null" [max]="maxDate" [disabled]="isView">
        </mat-form-field>
      </div>
    </div>
  </div>
  <br>
  <!-- <div *ngIf="this.voucher_type == 'Credit Note'">
  <mat-checkbox [(ngModel)]="isChecked" (change)="onCheckboxChange(pidata?.value,data?.value, 'Cr');onCheckboxChanges(pidata?.value,data?.value, 'Dr')">Fetch From Quality Check?</mat-checkbox>
</div> -->
  <br>
  <mat-card *ngIf="!showPurches && voucher_type !== 'Inventory Voucher' && this.voucher_type !== 'Credit Note' && this.voucher_type !== 'Debit Note'">
    <mat-card-content>
      <div style="display: flex;" class="debit-credit-section">
        <div style="width: 48%; margin-right: 20px;">
          <div class="san">
            <table class="mat-elevation-z8 demo-table">
              <thead>
                <tr>
                  <th colspan="6">DEBIT</th>
                </tr>
                <tr>
                  <th *ngIf="showinterbranch ||showadvinterbranch">SL No.</th>
                  <th *ngIf="showinterbranch ||showadvinterbranch">Branch</th>
                  <th>Employee Name</th>
                  <th>Ledger Name<span style="color: red">*</span></th>
                  <th>Amount<span style="color: red">*</span></th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let side of debitsides; let i = index">
                  <td *ngIf="showinterbranch ||showadvinterbranch">
                    <mat-form-field style="width: 50px; align-items: center;">
                      <input matInput [(ngModel)]="side.serialNumber">
                    </mat-form-field>
                  </td>
                  <td *ngIf="showinterbranch ||showadvinterbranch">
                    <div>
                      <mat-form-field style="width: 150px;">
                        <mat-label>Branch<span style="color: red">*</span></mat-label>
                        <mat-select placeholder="Select Branch" [(ngModel)]="side.fromBranch" #ledger
                          (selectionChange)="getLedgerData(side.fromBranch)" [disabled]="isView">
                          <mat-option *ngFor="let type of branchdata" [value]="type.id">{{ type.name }}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </td>
               <td>
                <mat-form-field>
                  <mat-label>Select Employee</mat-label>
                  <mat-select [(ngModel)]="side.employee_id">
                    <mat-option *ngFor="let emp of getSelectedEmployeeList()" [value]="emp.id">
                      {{ emp.adhar_name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                </td>
                  <td style="display: flex; align-items: center;">
                    <mat-form-field style="flex-grow: 1;">
                      <mat-label>Select Ledger</mat-label>
                      <mat-select [(ngModel)]="debitsides[i].debitLedgerType" panelClass="no-close-dropdown" (focus)="filterDrLedgers(side.fromBranch)" style="width: 800px;" [disabled]="isView">
                        <mat-option>
                          <mat-form-field>
                            <input matInput [(ngModel)]="searchDrText" placeholder="Search Ledger" (ngModelChange)="filterDrLedgers(side.fromBranch || '')" (click)="$event.stopPropagation()"/>
                          </mat-form-field>
                        </mat-option>
                        <ng-container *ngIf="debitsides[i].fromBranch">
                          <div style="max-height: 200px; overflow-y: auto;">
                          <mat-option *ngFor="let item of _filteredDrLedgers.get(side.fromBranch)" [value]="item.id">
                            {{ item.ledger_name }}
                          </mat-option>
                        </div>
                        </ng-container>
                        <ng-container *ngIf="!debitsides[i].fromBranch && (voucher_type != 'Credit Note') && (voucher_type != 'Debit Note')">
                          <div style="max-height: 200px; overflow-y: auto;">
                          <mat-option *ngFor="let item of _filteredDrLedgers.get(branch)" [value]="item.id">
                            {{ item.ledger_name }}
                          </mat-option>
                        </div>
                        </ng-container>
                        <ng-container *ngIf="!debitsides[i].fromBranch && (voucher_type == 'Credit Note')">
                          <div style="max-height: 200px; overflow-y: auto;">
                          <mat-option *ngFor="let item of filteredDrLedgers" [value]="item.ledger.id">
                            {{ item.ledger.ledger_name }}
                          </mat-option>
                          </div>
                        </ng-container>
                        <ng-container *ngIf="!debitsides[i].fromBranch && (voucher_type == 'Debit Note')">
                          <div style="max-height: 200px; overflow-y: auto;">
                          <mat-option *ngFor="let item of filteredDrLedgers" [value]="item.ledger.id">
                            {{ item.ledger.ledger_name }}
                          </mat-option>
                          </div>
                        </ng-container>
                      </mat-select>
                    </mat-form-field>
                    <button mat-icon-button (click)="openLedgerBookModal(debitsides[i].debitLedgerType)"
                      matTooltip="Open Ledger Book" [disabled]="!debitsides[i].debitLedgerType || isView">
                      <mat-icon>menu_book</mat-icon>
                    </button>
                    <button mat-icon-button (click)="openStatementViewModal(debitsides[i].debitLedgerType)"
                      matTooltip="Open Statement View" [disabled]="!debitsides[i].debitLedgerType || isView">
                      <mat-icon>description</mat-icon>
                    </button>
                  </td>
                  <td>
                    <mat-form-field>
                      <mat-label>Enter Amount{{ i + 1 }}</mat-label>
                      <input matInput type="number" [(ngModel)]="side.debitAmount" placeholder="Enter Amount" (ngModelChange)="onDebitAmountChange(side)" (keypress)="allowOnlyNumbers($event)" min="1"[disabled]="isView">
                    </mat-form-field>
                  </td>
                  <td>
                    <mat-form-field>
                      <mat-label>Enter Description{{ i + 1 }}</mat-label>
                      <input matInput type="text" [(ngModel)]="side.debitDescription" placeholder="Enter Description" [disabled]="isView">
                    </mat-form-field>
                  </td>
                  <td class="delete-btn">
                    <span mat-icon-button (click)="onRemovedebitSide(i)" *ngIf="debitsides.length > 1" [class.disabled-icon]="isView">
                      <img src="assets/img/delete.gif" alt="Delete" width="34" height="34">
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <br>
          <button mat-button color="primary" (click)="onAdddebitSide()" *ngIf="!isView"> + Add Debit Side</button>
          <br><br>
          <mat-card>
            <mat-card-content>
              <div>
                <strong>Total Debit Amount: {{ calculateTotalDebit() }}</strong>
              </div>
            </mat-card-content>
          </mat-card>
          <div mat-dialog-actions *ngIf="showinterbranch || showadvinterbranch">
            <button mat-button class="btn btn-primary" (click)="openPostingView()" [disabled]="isView">View</button>
          </div>
        </div>
        <div style="width: 48%; margin-left: 10px;">
          <div class="san">
            <table class="mat-elevation-z8 demo-table">
              <thead>
                <tr>
                  <th colspan="5">CREDIT</th>
                </tr>
                <tr>
                  <th *ngIf="showinterbranch ||showadvinterbranch">SL No.</th>
                  <th *ngIf="showinterbranch ||showadvinterbranch">Branch</th>
                  <th>Employee Name</th>
                  <th>Ledger Name<span style="color: red">*</span></th>
                  <th>Amount<span style="color: red">*</span></th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let side of creditsides; let i = index">
                  <td *ngIf="showinterbranch">
                    <mat-form-field style="width: 50px;">
                      <mat-label>Select Debit SL No.</mat-label>
                      <mat-select [(ngModel)]="side.debitSerialNumber"
                        (selectionChange)="onDebitSerialNumberChange(side)">
                        <mat-option (click)="resetDebitSerialNumber(side)" value="">None</mat-option>
                        <mat-option *ngFor="let debitSide of getAvailableDebitSides(side)"
                          [value]="debitSide.serialNumber">{{
                          debitSide.serialNumber }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </td>
                  <td *ngIf="showadvinterbranch">
                    <mat-form-field style="width: 50px;">
                      <mat-label>Select Debit SL No.</mat-label>
                      <mat-select [(ngModel)]="side.debitSerialNumber">
                        <mat-option  value="">None</mat-option>
                        <mat-option *ngFor="let debitSide of getAvailableDebitSides(side)"
                          [value]="debitSide.serialNumber">{{
                          debitSide.serialNumber }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </td>
                  <td *ngIf="showinterbranch ||showadvinterbranch">
                    <div>
                      <mat-form-field>
                        <mat-label>Branch<span style="color: red">*</span></mat-label>
                        <mat-select placeholder="Select Branch" [(ngModel)]="side.toBranch" #ledger
                          (selectionChange)="getLedgerDatas(side.toBranch)" [disabled]="!side.debitSerialNumber || isView">
                          <mat-option *ngFor="let type of branchdata" [value]="type.id">
                            {{ type.name }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </td>
              <td>
                <mat-form-field>
                  <mat-label>Select Employee Name</mat-label>
                  <mat-select [(ngModel)]="side.employee_id">
                    <mat-option *ngFor="let emp of getSelectedEmployeeList()" [value]="emp.id">
                      {{ emp.adhar_name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </td>
                  <td style="display: flex; align-items: center;">
                    <mat-form-field style="flex-grow: 1;">
                      <mat-label>Select Ledger</mat-label>
                      <mat-select [(ngModel)]="creditsides[i].creditLedgerType" panelClass="no-close-dropdown" (focus)="filterCrLedgers(side.toBranch)" style="width: 800px;" [disabled]="isView">
                        <mat-option>
                          <mat-form-field>
                            <input matInput [(ngModel)]="searchCrText" placeholder="Search Ledger" (ngModelChange)="filterCrLedgers(side.toBranch || '')"
                              (click)="$event.stopPropagation()" />
                          </mat-form-field>
                        </mat-option>
                        <ng-container *ngIf="creditsides[i].toBranch">
                          <div style="max-height: 200px; overflow-y: auto;">
                          <mat-option *ngFor="let item of _filteredCrLedgers.get(side.toBranch)" [value]="item.id">
                            {{ item.ledger_name }}
                          </mat-option>
                        </div>
                        </ng-container>
                        <ng-container *ngIf="!creditsides[i].toBranch && (voucher_type != 'Credit Note') && (voucher_type != 'Debit Note')">
                          <div style="max-height: 200px; overflow-y: auto;">
                          <mat-option *ngFor="let item of _filteredCrLedgers.get(branch)" [value]="item.id">
                            {{ item.ledger_name }}
                          </mat-option>
                        </div>
                        </ng-container>
                        <ng-container *ngIf="!creditsides[i].fromBranch && (voucher_type == 'Credit Note')">
                          <div style="max-height: 200px; overflow-y: auto;">
                          <mat-option *ngFor="let item of filteredCrLedgers" [value]="item.ledger.id">
                            {{ item.ledger.ledger_name }}
                          </mat-option>
                        </div>
                        </ng-container>
                        <ng-container *ngIf="!creditsides[i].fromBranch && (voucher_type == 'Debit Note')">
                          <div style="max-height: 200px; overflow-y: auto;">
                          <mat-option *ngFor="let item of filteredCrLedgers" [value]="item.ledger.id">
                            {{ item.ledger.ledger_name }}
                          </mat-option>
                        </div>
                        </ng-container>
                      </mat-select>
                    </mat-form-field>
                    <button mat-icon-button (click)="openLedgerBookModal(creditsides[i].creditLedgerType)"
                      matTooltip="Open Ledger Book" [disabled]="!creditsides[i].creditLedgerType || isView">
                      <mat-icon>menu_book</mat-icon>
                    </button>
                    <button mat-icon-button (click)="openStatementViewModal(creditsides[i].creditLedgerType)"
                      matTooltip="Open Statement View" [disabled]="!creditsides[i].creditLedgerType || isView">
                      <mat-icon>description</mat-icon>
                    </button>
                  </td>
                  <td>
                    <mat-form-field>
                      <mat-label>Enter Amount{{ i + 1 }}</mat-label>
                      <input matInput type="number" [(ngModel)]="side.creditAmount" placeholder="Enter Amount"
                        [disabled]="(side.debitSerialNumber && showinterbranch) || isView" (keypress)="allowOnlyNumbers($event)" min="1">
                    </mat-form-field>
                  </td>
                  <td>
                    <mat-form-field>
                      <mat-label>Enter Description{{ i + 1 }}</mat-label>
                      <input matInput type="text" [(ngModel)]="side.creditDescription" placeholder="Enter Description" [disabled]="isView">
                    </mat-form-field>
                  </td>
                  <td class="delete-btn">
                    <span mat-icon-button (click)="onRemovecreditSide(i)" *ngIf="creditsides.length > 1"  [class.disabled-icon]="isView">
                      <img src="assets/img/delete.gif" alt="Delete" width="34" height="34">
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>


          <br>
          <button mat-button color="primary" (click)="onAddcreditSide()" *ngIf="!isView"> + Add Credit Side</button>
          <br><br>
          <mat-card>
            <mat-card-content>
              <div>
                <strong>Total Credit Amount: {{ calculateTotalCredit() }}</strong>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
      <br>
      <mat-card>
        <mat-card-content>
          <mat-form-field>
            <mat-label>Enter Narration<span style="color: red">*</span></mat-label>
            <textarea matInput [(ngModel)]="narration" placeholder="Enter Narration" [disabled]="isView"></textarea>
          </mat-form-field>
        </mat-card-content>
      </mat-card>
      <br><br>
      <mat-form-field>
        <input matInput type="file" [(ngModel)]="file" class="img" multiple (change)="onFileSelected($event)"[disabled]="isView">
        <div class="file-names-container">
          <div *ngFor="let selectedFile of myFiles; let i = index" class="file-name">
            {{ selectedFile.name }}
            <button mat-icon-button (click)="removeFile(i)" [disabled]="isView">
              <mat-icon>clear</mat-icon>
            </button>
          </div>
        </div>
        <br>
        <br>
        <!-- <p mat-button *ngIf="operationType !== 'create'"class="click-here" (click)="openFileShowModal()">
          Click Here for see uploaded filess</p> -->
        <p mat-button *ngIf="!isView && (operationType !== 'create' || isDuplicate)" class="click-here" (click)="openFileShowModal()">
          Click Here to See Uploaded Files
        </p>
      </mat-form-field>
      <br>
      <div mat-dialog-actions>
        <button mat-button class="btn btn-primary" (click)="enterEditFromView()" *ngIf="isView && canEditFromView()">Edit</button>
        <button mat-button class="btn btn-danger" (click)="deleteVoucherFromView()" *ngIf="isView && canEditFromView()">Delete</button>
        <button mat-button class="btn btn-success" (click)="posting()" *ngIf="isView && showPostButton && is_posted != 1 && (approval_status == true || data.approval_status == 'Approved')">Post</button>
        <button mat-button class="btn btn-success" (click)="onSave()" *ngIf="!isView && type !== 'view'" [disabled]="data.approval_status === 'Pending' || data.approval_status === 'Approved'">{{ getButton() }}</button>
        <!-- <button mat-button class="btn btn-success" (click)="duplicateVoucher()">
          Duplicate
        </button> -->
        <button mat-button class="btn btn-success" (click)="duplicateVoucher()"
          *ngIf="data.id && !isDuplicate && (isView || operationType === 'view' || operationType === 'update')">
          Duplicate
        </button>
        <button mat-button class="btn btn-primary" *ngIf="!isView && data.id && (data.approval_status == null || data.approval_status == 'Open' || data.approval_status == 'Rejected')" (click)="sendForApprove()">Send For Approval</button>
        <button mat-button class="btn btn-info" *ngIf="!isView && data.id && (data.approval_status == 'Pending' || data.approval_status == 'Rejected' || data.approval_status == 'Approved')" (click)="showApprovalTimeline()">
          <mat-icon>timeline</mat-icon>
          Approval Timeline
        </button>
        <button mat-button class="btn btn-danger" mat-dialog-close>Cancel</button>
      </div>
    </mat-card-content>
  </mat-card>
  <mat-card *ngIf="showPurches && voucher_type !== 'Inventory Voucher'">
    <mat-card-content>
      <div style="display: flex;gap: 20px;">
        <div style="display: flex; flex-wrap: wrap; gap: 10px; align-items: flex-start; margin-left: 10px;">
          <!-- vendor -->
          <mat-form-field style="flex: 1; min-width: 100px;" *ngIf="this.voucher_type === 'Purchase'">
            <mat-label>Select Vendor</mat-label>
            <mat-select [(ngModel)]="vendor" placeholder="Select Vendors" (selectionChange)="onVendorChange($event.value)" [disabled]="isUpdate || isView">
              <mat-option *ngFor="let item of vendorData" [value]="item.id">{{ item.vendor_name }}</mat-option>
            </mat-select>
          </mat-form-field>
          <!-- vendor branch -->
          <mat-form-field style="flex: 1; min-width: 200px;" *ngIf="vendorBranchData && vendorBranchData.length > 0">
            <mat-label>Select Vendor Branch</mat-label>
            <mat-select [(ngModel)]="selectedVendorBranch" placeholder="Select Vendor Branch" (selectionChange)="gstType();onVendorBranchChange($event.value)" [disabled]="isUpdate || isView">
              <mat-option *ngFor="let item of vendorBranchData" [value]="item.id">{{ item.branch_name }}</mat-option>
            </mat-select>
          </mat-form-field>
            <mat-form-field style="flex: 1; min-width: 200px;" *ngIf="this.voucher_type === 'Purchase'">
            <mat-label>Select Section</mat-label>
            <mat-select [(ngModel)]="selectedPiSection" placeholder="Select Section" (selectionChange)="onPiSectionChange($event.value)" [disabled]="isUpdate || isView" multiple>
              <mat-option *ngFor="let item of filteredSections" [value]="item.id">{{ item.section_name }}</mat-option>
            </mat-select>
          </mat-form-field>
          <!-- vendor grn -->
          <mat-form-field style="flex: 1; min-width: 200px;" *ngIf="this.voucher_type === 'Purchase' && is_pi_si_manual != 1">
            <mat-label>Select GSRN<span style="color: red">*</span></mat-label>
            <mat-select [(ngModel)]="selectedGrn" multiple placeholder="Select GSRN" [disabled]="selectedItem || data.approval_status === 'Pending' || isView">
              <mat-option *ngFor="let item of grn" [value]="item.id">
                {{ item.grn_no }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        <!-- customer -->
          <mat-form-field style="flex: 1; min-width: 200px;" *ngIf="this.voucher_type === 'Sales'">
            <mat-label>Select Customer</mat-label>
            <mat-select [(ngModel)]="customer" placeholder="Select Customer" (selectionChange)="onCustomerChange($event.value)" [disabled]="isUpdate || isView">
              <mat-option *ngFor="let item of customerData" [value]="item.id">{{ item.customer_name }}</mat-option>
            </mat-select>
          </mat-form-field>
          <!-- customer branch -->
          <mat-form-field style="flex: 1; min-width: 200px;" *ngIf="customerBranchData && customerBranchData.length > 0">
            <mat-label>Select Customer Branch</mat-label>
            <mat-select [(ngModel)]="selectedCustomerBranch" placeholder="Select Customer Branch" (selectionChange)="gstType();onCustomerBranchChange($event.value)" [disabled]="isUpdate || isView">
              <mat-option *ngFor="let item of customerBranchData" [value]="item.id">{{ item.branch_name }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field style="flex: 1; min-width: 200px;" *ngIf="this.voucher_type === 'Sales'">
            <mat-label>Select Section</mat-label>
            <mat-select [(ngModel)]="selectedSection" placeholder="Select Section" (selectionChange)="onSectionChange($event.value)" [disabled]="isUpdate || isView" multiple>
              <mat-option *ngFor="let item of filteredSections" [value]="item.id">{{ item.section_name }}</mat-option>
            </mat-select>
          </mat-form-field>
        <!-- customer gsn -->
          <mat-form-field style="flex: 1; min-width: 200px;" *ngIf="this.voucher_type === 'Sales' && is_pi_si_manual != 1">
            <mat-label>Select GSSN<span style="color: red">*</span></mat-label>
            <mat-select [(ngModel)]="selectedGsn" multiple placeholder="Select GSSN" [disabled]="selectedItem || data.approval_status === 'Pending' || isView">
              <mat-option *ngFor="let item of gsn" [value]="item.id">
                {{ item.gsn_no }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div style="flex: 1;">
            <button mat-raised-button color="primary" (click)="onSearchClick()" 
                [disabled]="(!selectedGsn || selectedGsn.length === 0) && (!selectedGrn || selectedGrn.length === 0) && (data.approval_status === 'Pending')" style="margin-left: 10px;margin-top: 15px;">
                Search
            </button>
        </div>
        </div>
        <div style="width: 20%; margin-left: 20px;">
          <mat-form-field style="width: 100%;">
            <mat-label>External Document No<span style="color: red">*</span></mat-label>
            <input matInput type="text" [(ngModel)]="document_no" placeholder="External Document No" [disabled]="data.approval_status === 'Pending'">
          </mat-form-field>
        </div>
        <div style="width: 10%; margin-left: 30px;">
          <mat-form-field style="width: 100%;">
            <mat-label>Document Date<span style="color: red">*</span></mat-label>
            <input type="date" matInput [(ngModel)]="issue_date" placeholder="DD/MM/YYYY" [max]="maxDate" [disabled]="data.approval_status === 'Pending'">
          </mat-form-field>
        </div>
      </div>
      <div 
      class="card mat-elevation-z4" 
      style="height: 80px; background-color: #f0f0f0;" 
      *ngIf="is_pi_si_manual == 1">
              <div style="display: flex; gap: 10px; align-items: center; margin-left: 10px;">
          <div style="flex: 1; width: 100%; margin-top: 10px;">
            <mat-form-field>
              <mat-label>Select SKU/Service<span style="color: red">*</span></mat-label>
              <mat-select [(ngModel)]="selectedItem" (ngModelChange)="onSelectionChange($event)" placeholder="Select SKU/Services">
                <ng-container *ngFor="let group of combinedDropdownData">
                  <mat-optgroup [label]="group.category">
                    <mat-option *ngFor="let item of group.items" [value]="item">
                      {{ item.item_name || item.service_name }}
                    </mat-option>
                  </mat-optgroup>
                </ng-container>
              </mat-select>
            </mat-form-field>
          </div>
          <div style="flex: 1;width:100px;margin-top: 10px;">
            <mat-form-field>
              <mat-label>HSN/SAC No</mat-label>
              <input matInput type="text" [(ngModel)]="hsn_no" placeholder="HSN/SAC No" disabled>
            </mat-form-field>
          </div>
          <div style="flex: 1;width:100%;margin-top: 10px;">
            <mat-form-field>
              <mat-label>Enter Description<span style="color: red">*</span></mat-label>
              <input matInput type="text" [(ngModel)]="selectedDescription" placeholder="Enter Description" disabled>
            </mat-form-field>
          </div>
          <div style="flex: 1;width:100px;margin-top: 10px;">
            <mat-form-field>
              <mat-label>UoM</mat-label>
              <input matInput type="text" [(ngModel)]="unit" placeholder="UoM" disabled>
            </mat-form-field>
          </div>
          <div style="flex: 1;width:100px;margin-top: 10px;">
            <mat-form-field>
              <mat-label>QTY<span style="color: red">*</span></mat-label>
              <input matInput type="number" [(ngModel)]="selectedQty" placeholder="QTY" (keypress)="allowOnlyNumbers($event)" min="1" [disabled]="isView">
            </mat-form-field>
          </div>
          <div style="flex: 1;width:150px;margin-top: 10px;">
            <mat-form-field>
              <mat-label>Unit Price<span style="color: red">*</span></mat-label>
              <input matInput type="number" [(ngModel)]="selectedUnitPrice" placeholder="Unit Price" (keypress)="allowOnlyNumbers($event)" min="1" [disabled]="isView">
            </mat-form-field>
          </div>
          <div style="flex: 1;width:100px;margin-top: 10px;">
            <mat-form-field>
              <mat-label>Discount(%)</mat-label>
              <input matInput type="number" [(ngModel)]="selectedDiscount" placeholder="Discount" (keypress)="allowOnlyNumbers($event)" min="0" [disabled]="isView">
            </mat-form-field>
          </div>
          <div style="flex: 1;width:100px;margin-top: 10px;">
            <mat-form-field>
              <mat-label>Tax<span style="color: red">*</span></mat-label>
              <mat-select [(ngModel)]="selectedTaxType" placeholder="Select Tax" [disabled]="isView">
                <mat-option *ngFor="let item of tax" [value]="item.global_gst_id">{{ item.gst_percentage }}%</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div style="flex: 1;width:150px;margin-top: 10px;">
            <button mat-raised-button color="primary" (click)="addProduct()" *ngIf="!isView">Add Product</button>
          </div>
        </div>
      </div>
      <div class="card mat-elevation-z4" style="background-color: #f0f0f0;">
        <mat-card>
          <mat-card-content>
            <mat-form-field>
              <mat-label>Enter Narration<span style="color: red">*</span></mat-label>
              <textarea matInput [(ngModel)]="purchesnarration" placeholder="Enter Narration" [disabled]="data.approval_status === 'Pending' || isView"></textarea>
            </mat-form-field>
          </mat-card-content>
        </mat-card>
        <mat-form-field>
          <input matInput type="file" class="img" multiple (change)="onFileSelected($event)" [disabled]="isView">
          <div class="file-names-container">
            <div *ngFor="let selectedFile of myFiles; let i = index" class="file-name">
              {{ selectedFile.name }}
              <button mat-icon-button (click)="removeFile(i)" [disabled]="isView">
              <mat-icon>clear</mat-icon>
            </button>
          </div>
        </div>
        <br>
        <br>
          <p mat-button *ngIf="!isView && operationType!== 'create'" class="click-here" (click)="openVoucherFileShowModal()">
          Click Here for see uploaded file</p>
      </mat-form-field>
      </div>
      <div *ngIf="productEntries.selectedGrn?.length === 0">
        <table class="product-table">
          <thead>
            <tr>
              <th>SKU Name</th>
              <th>HSN/SAC No</th>
              <th>Description</th>
              <th>Units</th>
              <th>QTY</th>
              <th>Unit Price</th>
              <th>Value</th>
              <th>Discount(%)</th>
              <th>Discounted Amount</th>
              <th>CGST</th>
              <th>SGST</th>
              <th>IGST</th>
              <th>Gst Amount</th>
              <th *ngIf="!isView">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let entry of productEntries; let i = index">
              <td>{{ getProductTypeName(entry.productType) }}</td>
              <td style="display: none;">{{ entry.ledger_id}}</td>
              <td>{{ entry.hsn_no }}</td>
              <td class="description-column">{{ entry.description }}</td>
              <td>{{ entry.unit }}</td>
              <td>{{ entry.qty }}</td>
              <td>{{ entry.unitPrice | number:'1.2-2' }}</td>
              <td>{{ entry.qty * entry.unitPrice | number:'1.2-2' }}</td>
              <td>{{ entry.discount | number:'1.2-2' }}%</td>
              <td>{{ (entry.qty * entry.unitPrice * entry.discount / 100) | number:'1.2-2' }}</td>
              <td>{{ lineItemCgstAmount(entry) | number: '1.2-2' }} <span *ngIf="gstMatch() && vendorBranchGstType === 'REGISTER'">({{ getCGSTPercentage(entry.taxType) | number: '1.2-2' }}%)</span></td>
              <td>{{ lineItemSgstAmount(entry) | number: '1.2-2' }} <span *ngIf="gstMatch() && vendorBranchGstType === 'REGISTER'">({{ getSGSTPercentage(entry.taxType) | number: '1.2-2' }}%)</span></td>
              <td>{{ lineItemIgstAmount(entry) | number: '1.2-2' }}<span *ngIf="gstMatch() === false && vendorBranchGstType === 'REGISTER'">({{ getIGSTPercentage(entry.taxType) | number: '1.2-2' }}%)</span></td>
              <td>{{productTaxAmount(entry) | number: '1.2-2' }}</td>
              <td *ngIf="!isView">
                <mat-icon (click)="editProduct(i)">edit</mat-icon>
                <mat-icon (click)="deleteProduct(i)">delete</mat-icon>
              </td>
            </tr>
          </tbody>
        </table>
        <br>
        <div>
          <div>
            <mat-form-field>
              <mat-label>Rounded</mat-label>
              <input matInput type="number" [(ngModel)]="roundedamount" placeholder="Rounded Amount" [disabled]="isView">
            </mat-form-field>
            <!-- <mat-form-field>
              <mat-select [(ngModel)]="ledger" placeholder="Select Ledger">
                <mat-option value="" disabled>Select Ledger</mat-option>
                <mat-option *ngFor="let type of rounded_ledger_data" [value]="type.ledger_id">{{ type.ledger_name }}</mat-option>
              </mat-select>
            </mat-form-field>             -->
            <mat-form-field appearance="outline" style="width: 100%;" (scroll)="onLedgerScroll($event)">
              <mat-label>Select Ledger</mat-label>
              <mat-select [(ngModel)]="ledger" panelClass="ledger-select-panel" (openedChange)="onLedgerOpen($event)" [disabled]="isView">
                <mat-select-header class="ledger-search-header">
                  <input matInput placeholder="Search Ledger..." (keyup)="filterLedger($event)" (click)="$event.stopPropagation()"
                    (keydown)="$event.stopPropagation()" />
                </mat-select-header>
            
                <mat-option [value]="null">Select Ledger</mat-option>
            
                <mat-option *ngFor="let item of rounded_ledger_data" [value]="item.ledger_id">
                  {{ item.ledger_name }}
                </mat-option>
            
              </mat-select>
            </mat-form-field>
          </div>
          <div class="gst-total">
            <span>Total Discount: {{ getTotaldiscount() | number: '1.2-2' }}</span>
          </div>
          <div class="gst-total">
            <span>Sub Total Amount: {{ getTotalAmount() | number: '1.2-2' }}</span>
          </div>
          <div class="gst-total">
            <span>Total GST Amount: {{ getTotalGSTAmount() | number: '1.2-2' }}</span>
          </div>
          <div class="gst-total">
            <span>Total Amount: {{ getTotalAmount() + getTotalGSTAmount() | number: '1.2-2' }}</span>
          </div>
          <div class="gst-total">
            <span>
              Round {{ roundedamount < 0 ? 'Down' : (roundedamount> 0 ? 'Up' : '') }} Amount: {{ roundedamount | number:
                '1.2-2' }}
            </span>
          </div>
          <div class="row">
            <span>total_credit:{{ totalcredit() | number: '1.2-2' }}</span>
          </div>
          <div class="row">
            <span>total_debit:{{ getTotalRoundedAmount() | number: '1.2-2' }}</span>
          </div>
          <div mat-dialog-actions>
            <button mat-button class="btn btn-primary" (click)="enterEditFromView()" *ngIf="isView && canEditFromView()">Edit</button>
        <button mat-button class="btn btn-danger" (click)="deleteVoucherFromView()" *ngIf="isView && canEditFromView()">Delete</button>
        <button mat-button class="btn btn-success" (click)="posting()" *ngIf="isView && showPostButton && is_posted != 1 && (approval_status == true || data.approval_status == 'Approved')">Post</button>
            <button mat-button class="btn btn-success" (click)="detail()" *ngIf="!isView && type !== 'view'" [disabled]="data.approval_status === 'Pending' || data.approval_status === 'Approved'">{{ getButton() }}</button>
            <button mat-button class="btn btn-primary" (click)="openproductView()" *ngIf="!isView">View</button>
            <button mat-button class="btn btn-primary" (click)="convertToPdf()" *ngIf="!isView">Download pdf</button>
            <button mat-button class="btn btn-primary" *ngIf="!isView && data.id && (data.approval_status == null || data.approval_status == 'Open' || data.approval_status == 'Rejected')" (click)="sendForApprove()">Send For Approval</button>
            <button mat-button class="btn btn-info"   *ngIf="!isView && data.id && (data.approval_status == 'Pending' || data.approval_status == 'Rejected' || data.approval_status == 'Approved')" (click)="showApprovalTimeline()">
                <mat-icon>timeline</mat-icon>
                Approval Timeline
            </button>
            <button mat-button class="btn btn-danger" mat-dialog-close>Cancel</button>
          </div>
        </div>
      </div>
      <div *ngIf="selectedGrn && selectedGrn.length > 0 || selectedGsn && selectedGsn.length > 0 ">
        <table style="width: 100%; border-collapse: collapse; text-align: left;" class="product-table" *ngIf="productList.length > 0">
          <thead>
            <tr>
              <th *ngIf="this.voucher_type == 'Sales'">GSSN No</th>
              <th *ngIf="this.voucher_type == 'Purchase'">GSRN No</th>
              <th>Section</th>
              <th *ngIf="this.voucher_type == 'Sales'">Profit Cost</th>
              <th *ngIf="this.voucher_type == 'Sales'">Line Document No</th>
              <th *ngIf="this.voucher_type == 'Sales'">Product Service No</th>
              <th>Category Name</th>
              <th>Item/service Name</th>
              <th>HSN/SAC No</th>
              <th *ngIf="this.voucher_type == 'Purchase'">Specification</th>
              <th>Description</th>
              <th>Units</th>
              <th>QTY</th>
              <th *ngIf="this.voucher_type == 'Purchase'">Pass QTY</th>
              <th>Unit Price</th>
              <th>Actual Value</th>
              <!-- <th>Discount(%)</th> -->
              <th *ngIf="this.voucher_type == 'Sales'">Discounted Amount</th>
              <th *ngIf="this.voucher_type == 'Sales'">Incentive Amount</th>
              <th *ngIf="this.voucher_type == 'Sales'">Final value</th>
              <th>CGST</th>
              <th>SGST</th>
              <th>IGST</th>
              <th>Gst Amount</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let product of productList">
              <ng-container *ngFor="let detail of product.details;let i = index">
                <tr>
                  <!-- <td>{{detail?.item_service_type === 'SKU' ?
                                    detail?.sku?.sku_name : detail?.service?.service_name }}</td> -->
                  <td *ngIf="this.voucher_type == 'Sales'">{{detail?.gsn?.gsn_no}}</td>
                  <td *ngIf="this.voucher_type == 'Purchase'">{{detail?.grn?.grn_no}}</td>
                  <td>{{ detail?.section?.section_name }}</td>
                  <td *ngIf="this.voucher_type == 'Sales'">{{ detail?.profit_cost?.name }}</td>
                  <td *ngIf="this.voucher_type == 'Sales'">{{ detail.line_document_no }}</td>
                  <td *ngIf="this.voucher_type == 'Sales'">{{ detail.product_service_no }}</td>
                  <td>{{
                    detail.item_service_type === 'SKU'
                    ? detail?.sku?.profit_cost_category?.category?.category_name
                    : detail.item_service_type === 'Service'
                    ? detail?.service?.profit_cost_category?.category?.category_name
                    : detail.item_service_type === 'Fixed Asset'
                    ? detail?.fa_template?.home_entity_category?.category_name
                    : ''
                    }}</td>                  
                  <td>
                    {{
                    detail.item_service_type === 'SKU'
                    ? detail?.sku?.item?.item_name
                    : detail.item_service_type === 'Service'
                    ? detail?.service?.service_name
                    : detail.item_service_type === 'Fixed Asset'
                    ? detail?.fa_template?.name
                    : ''
                    }}
                  </td>
                  <td>{{ detail.item_service_type === 'SKU'
                    ? detail.hsn_no
                    : detail.item_service_type === 'Service'
                    ? detail?.hsn_no
                    : detail.item_service_type === 'Fixed Asset'
                    ? detail?.hsn_no
                    : ''}}</td>
                  <td *ngIf="this.voucher_type == 'Purchase'">{{ detail.specification }}</td>
                  <td>{{ detail.description }}</td>
                  <td>{{ detail.unit.unit_name }}</td>     
                  <td>{{ selectedGrn.length !==0 ? detail.receive_qty : detail.send_qty | number:'1.3-3' }}</td>
                  <td *ngIf="this.voucher_type == 'Purchase'">{{ getPassQtyForSku(product, detail?.sku_id) }}</td>
                  <td>{{ detail.unit_price | number:'1.2-2' }}</td>
                  <td>{{ (selectedGrn.length !==0 ? detail.receive_qty * detail.unit_price : detail.send_qty *
                    detail.unit_price) | number:'1.2-2' }}</td>
                  <!-- <td>{{ 0 }}</td> -->
                  <td *ngIf="this.voucher_type == 'Sales'">
                    <span>{{ detail.discount_amount | number:'1.2-2' }}</span>
                  </td>
                  <td *ngIf="this.voucher_type == 'Sales'">
                    <span>{{ detail.incentive_amount | number:'1.2-2' }}</span>
                  </td>
                  <td *ngIf="this.voucher_type == 'Sales'">{{(selectedGrn.length !==0 ? detail.receive_qty * detail.unit_price : detail.send_qty *
                    detail.unit_price) - detail?.discount_amount + detail?.incentive_amount | number:'1.2-2' }}</td>
                  <td>{{ cgstAmount(detail)}} <span *ngIf="gstMatch() && vendorBranchGstType === 'REGISTER'">({{
                      getCGSTPercentage(detail.hsn_sac.gst_id)
                      }}%)</span></td>
                  <td>{{ sgstAmount(detail)}} <span *ngIf="gstMatch() && vendorBranchGstType === 'REGISTER'">({{
                      getSGSTPercentage(detail.hsn_sac.gst_id)
                      }}%)</span></td>
                  <td>{{ igstAmount(detail)}} <span *ngIf="gstMatch() === false && vendorBranchGstType === 'REGISTER'">({{
                      getIGSTPercentage(detail.hsn_sac.gst_id) }}%)</span></td>
                  <td>{{productTaxAmount2(detail) | number:'1.2-2' }}</td>
                  </tr>
              </ng-container>
            </ng-container>
          </tbody>
        </table>
        <br>
        <div *ngIf="productList.length > 0">
          <div style="margin-bottom: 15px;" *ngIf="selectedGrn && selectedGrn.length > 0 && !isView">
            <button mat-raised-button color="primary" (click)="editHsnGst(productList)">Edit Hsn Gst</button>
          </div>
          <div>
            <mat-form-field>
              <mat-label>Rounded</mat-label>
              <input matInput type="number" [(ngModel)]="roundedamount2" placeholder="Rounded Amount" [disabled]="isView">
            </mat-form-field>
            <!-- <mat-form-field>
              <mat-select [(ngModel)]="ledger" placeholder="Select Ledger">
                <mat-option [value]="null">Select Ledger</mat-option>
                <mat-option *ngFor="let type of rounded_ledger_data" [value]="type.ledger_id">{{ type.ledger_name }}</mat-option>
              </mat-select>
            </mat-form-field> -->
            <mat-form-field appearance="outline" style="width: 100%;" >
              <mat-label>Select Ledger</mat-label>
            
              <mat-select #ledgerSelect [(ngModel)]="ledger" panelClass="ledger-select-panel" (openedChange)="onLedgerOpen($event)"  (scroll)="onLedgerScroll($event)">
            
                <mat-select-header class="ledger-search-header">
                  <input matInput placeholder="Search Ledger..." (keyup)="filterLedger($event)" (click)="$event.stopPropagation()"
                    (keydown)="$event.stopPropagation()" />
                </mat-select-header>
            
                <mat-option [value]="null">Select Ledger</mat-option>
            
                <mat-option *ngFor="let item of rounded_ledger_data" [value]="item.ledger_id">
                  {{ item.ledger_name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="gst-total">
            <span>Total Discount: {{ getTotaldiscount2() | number: '1.2-2' }}</span>
          </div>
           <div class="gst-total" *ngIf="getTotalDiscountAmount() > 0">
            <span>Total Discounted Amounts: {{ getTotalDiscountAmount() | number: '1.2-2' }}</span>
          </div>
           <div class="gst-total" *ngIf="getTotalInceptiveAmount() > 0">
            <span>Total Incentive Amount: {{ getTotalInceptiveAmount() | number: '1.2-2' }}</span>
          </div>
          <div class="gst-total">
            <span>Sub Total Amount: {{ getTotalAmount2() | number: '1.2-2' }}</span>
          </div>
          <div class="gst-total">
            <span>Total GST Amount: {{ getTotalGSTAmount2() | number: '1.2-2' }}</span>
          </div>
          <div class="gst-total">
            <span>Total Amount: {{ getTotalAmount2() + getTotalGSTAmount2() | number: '1.2-2' }}</span>
          </div>
          <div class="gst-total">
            <span>
              Round {{ roundedamount2 < 0 ? 'Down' : (roundedamount2> 0 ? 'Up' : '') }} Amount: {{ roundedamount2 | number:
                '1.2-2' }}
            </span>
          </div>
          <div class="gst-total">
            <span>total_credit:{{ totalcredit2() | number: '1.2-2' }}</span>
          </div>
          <div class="gst-total">
            <span>total_debit:{{ getTotalRoundedAmount2() | number: '1.2-2' }}</span>
          </div>
          <div mat-dialog-actions>
            <button mat-button class="btn btn-primary" (click)="enterEditFromView()" *ngIf="isView && canEditFromView()">Edit</button>
        <button mat-button class="btn btn-danger" (click)="deleteVoucherFromView()" *ngIf="isView && canEditFromView()">Delete</button>
        <button mat-button class="btn btn-success" (click)="posting()" *ngIf="isView && showPostButton && is_posted != 1 && (approval_status == true || data.approval_status == 'Approved')">Post</button>
            <button mat-button class="btn btn-success" *ngIf="!isView && type !== 'view'" [disabled]="data.approval_status === 'Approved'" (click)="detail()">{{ getButton() }}</button>
            <button mat-button class="btn btn-primary" (click)="openproductView()" *ngIf="!isView">View</button>
            <ng-container *ngIf="!isView && isPurchase">
              <button mat-button class="btn btn-primary" (click)="convertToPdf()">Download pdf</button>
            </ng-container>
            <ng-container *ngIf="!isView && isSales">
              <button mat-button class="btn btn-primary" (click)="convertToPdf('original')">
                Download Original Copy
            </button>             
            <button mat-button class="btn btn-primary" (click)="convertToPdf('duplicate')">
                Download Duplicate Copy
            </button>             
            <button mat-button class="btn btn-primary" (click)="convertToPdf('extra')">
                Download Extra Copy
            </button> 
            </ng-container>
            <!-- <button mat-button class="btn btn-success" (click)="detail()" *ngIf="type !== 'view'" [disabled]="data.approval_status === 'Pending' || data.approval_status === 'Approved'">{{ getButton() }}</button> -->
            <button mat-button class="btn btn-primary" *ngIf="!isView && data.id && (data.approval_status == null || data.approval_status == 'Open' || data.approval_status == 'Rejected')" (click)="sendForApprove()">Send For Approval</button>
            <button mat-button class="btn btn-info" *ngIf="!isView && data.id && (data.approval_status == 'Pending' || data.approval_status == 'Rejected' || data.approval_status == 'Approved')" (click)="showApprovalTimeline()">
              <mat-icon>timeline</mat-icon>
              Approval Timeline
            </button>
            <button mat-button class="btn btn-danger" mat-dialog-close>Cancel</button>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

    <mat-card *ngIf="this.voucher_type == 'Inventory Voucher'">
          <mat-card-content>
            <div style="display: flex;gap: 20px;">
              <div style="display: flex; flex-wrap: wrap; gap: 10px; align-items: flex-start; margin-left: 10px;">
                <mat-form-field style="flex: 1; min-width: 100px;">
                  <mat-select [(ngModel)]="inv_branch" placeholder="Select Branch" [disabled]="isInputDisabled"
                    (ngModelChange)="onInvBranchChange($event)" [disabled]="isUpdate">
                    <mat-option *ngFor="let type of branchdata" [value]="type.id">{{ type.name }}</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field>
                  <mat-select [(ngModel)]="profitcost_id" placeholder="Select Profit Cost"
                    (ngModelChange)="onProfitCostChange($event)" [disabled]="isUpdate">
                    <mat-option *ngFor="let profitcost of ProfitCostData" [value]="profitcost.id">
                      {{ profitcost.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field>
                  <mat-select [(ngModel)]="store_id" placeholder="Select Store" [disabled]="isInputDisabled" [disabled]="isUpdate">
                    <mat-option *ngFor="let type of store_data" [value]="type.id">{{ type.store_name }}</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field>
                  <mat-select [(ngModel)]="inv_section_id" placeholder="Select Section" [disabled]="isInputDisabled" multiple
                    (ngModelChange)="fetchInventorySku()" [disabled]="isUpdate">
                    <mat-option *ngFor="let type of section_data" [value]="type.id">{{ type.section_name }}</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field *ngIf="sku.length > 0">
                  <mat-select placeholder="Select SKU" [(ngModel)]="selectedSkuId" (ngModelChange)="onSelectSku()" multiple [disabled]="isUpdate">
                    <mat-option *ngFor="let s of sku" [value]="s.id">
                      {{ s.sku?.sku_name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          <div *ngIf="tableSkus.length > 0" class="sku-container">
            <mat-card *ngFor="let sku_list of tableSkus" class="sku-card">
          
              <!-- Header Row -->
                <div style="display: flex;gap: 20px;">
                  <div style="display: flex; flex-wrap: wrap; gap: 10px; align-items: flex-start; margin-left: 10px;">
                    <div style="display: flex; justify-content: start; gap: 30px;">
                      {{ sku_list.sku?.sku_name }}
                    </div>
                    <div style="display: flex; justify-content: start; gap: 30px;">
                      {{ sku_list.qty }}
                    </div>
                    <div style="display: flex; justify-content: start; gap: 30px;">
                      <button mat-mini-fab color="primary" (click)="addSO(sku_list)"
                        [disabled]="getTotalQty(sku_list) >= sku_list.qty">+</button>
                    </div>
                  </div>
                </div>
              <mat-card-content>
                <table *ngIf="sku_list.soList?.length > 0" class="table table-sm table-striped"
                  style="margin-top:10px; width:100%;">
                  <thead>
                    <tr>
                      <th>Employee</th>
                      <th>Qty</th>
                      <th>Breakdown</th>
                      <th>Total Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let so of sku_list.soList; let i = index">
                      <td>
                        <mat-form-field appearance="outline" style="width: 120px;">
                          <mat-select [(ngModel)]="so.employee_id" placeholder="Employee">
                            <mat-option *ngFor="let emp of employee_data" [value]="emp.papl_id">
                              {{ emp.name }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </td>
                      <td>
                        <mat-form-field appearance="outline" style="width: 80px;">
                          <input matInput type="number" [(ngModel)]="so.selectQty" placeholder="Qty" min="1"
                            (keypress)="allowOnlyNumbers($event)" (ngModelChange)="onQtyChange(sku_list, so)" />
                        </mat-form-field>
                      </td>
                      <td>
                        <div *ngIf="so.lifoBreakdown?.length">
                          <div *ngFor="let line of so.lifoBreakdown">
                            {{ line }}
                          </div>
                        </div>
                      </td>
                      <td>
                        {{ so.lifoValue | number:'1.2-2' }}
                      </td>
          
                    </tr>
                  </tbody>
                </table>
              </mat-card-content>
            </mat-card>
          </div>
            <div mat-dialog-actions>
              <button mat-button class="btn btn-primary" (click)="enterEditFromView()" *ngIf="isView && canEditFromView()">Edit</button>
        <button mat-button class="btn btn-danger" (click)="deleteVoucherFromView()" *ngIf="isView && canEditFromView()">Delete</button>
        <button mat-button class="btn btn-success" (click)="posting()" *ngIf="isView && showPostButton && is_posted != 1 && (approval_status == true || data.approval_status == 'Approved')">Post</button>
              <button mat-button class="btn btn-success" (click)="SaveInventory()" *ngIf="!isView && type !== 'view'" [disabled]="data.approval_status === 'Pending' || data.approval_status === 'Approved'">{{ getButton() }}</button>
              <button mat-button class="btn btn-primary" *ngIf="!isView && data.id && (data.approval_status == null || data.approval_status == 'Open' || data.approval_status == 'Rejected')" (click)="sendForApprove()">Send For Approval</button>
              <button mat-button class="btn btn-info" *ngIf="!isView && data.id  && (data.approval_status == 'Pending' || data.approval_status == 'Rejected' || data.approval_status == 'Approved')" (click)="showApprovalTimeline()">
                  <mat-icon>timeline</mat-icon>
                  Approval Timeline
              </button>
              <button mat-button class="btn btn-danger" mat-dialog-close>Cancel</button>
            </div>
          </mat-card-content>
        </mat-card>

  <mat-card *ngIf="this.voucher_type == 'Credit Note'&& this.invoice_type == 'sales'">
    <mat-card-content>
      <div>
        <h5><b>List of Item/Service</b></h5>
      </div>
      <div *ngIf="salesInvoice">
        <table class="product-table">
          <thead>
            <tr>
              <th>Profit/Cost</th>
              <th>Section</th>
              <th>Item/Service Name</th>
              <th>HSN/SAC No</th>
              <th>Description</th>
              <th>UOM</th>
              <th>Unit Price</th>
              <th>Quantity</th>
              <th>Value</th>
              <th>Discount</th>
              <th>Incentive</th>
              <th>GST %</th>
              <th>Pending Quantity</th>
              <th>Change Quantity</th>
              <th>Change Value</th>
              <th>Final discount</th>
              <th>Final incentive</th>
              <th>Final Value</th>
              <th>CGST</th>
              <th>SGST</th>
              <th>IGST</th>
              <th>Total GST Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let entry of sales_invoice_details; let i = index">
              <td>{{ entry?.profit_cost_name}}</td>
              <td>{{ entry?.section_name }}</td>
              <td>{{ entry?.name}}</td>
              <td>{{ entry?.hsn_no }}</td>
              <td>{{ entry?.description }}</td>
              <td>{{ entry?.unit_name }}</td>
              <td>{{ entry?.unit_price | number:'1.2-2' }}</td>
              <td>{{ entry?.qty | number:'1.3-3' }}</td>
              <td>{{ entry?.qty * entry?.unit_price | number:'1.2-2' }}</td>
              <td>{{ entry?.discount_amount | number:'1.2-2' }}</td>
              <td>{{ entry?.incentive_amount | number:'1.2-2' }}</td>
              <td>{{ entry?.gst_percentage | number:'1.2-2' }}</td>
              <td>{{ entry?.pending_qty| number:'1.3-3' }}</td>
              <td><mat-form-field appearance="outline" style="width: 100px;">
                  <input matInput type="number" [(ngModel)]="entry.change_qty"
                    (ngModelChange)="QtyChange(entry,entry.change_qty,entry.unit_price)" min="0.001" step="0.001"
                    [disabled]="type != 2 || isView" />
                </mat-form-field>
              </td>
              <td>
                <mat-form-field appearance="outline" style="width: 120px;">
                  <input matInput type="number" [(ngModel)]="entry.change_value"
                    (ngModelChange)="PriceChange(entry,entry.qty,entry.change_value)" min="0.01" step="0.01"
                    [disabled]="type != 1 || isView" />
                </mat-form-field>
              </td>
              <td>{{ entry?.final_discount | number:'1.2-2' }}</td>
              <td>{{ entry?.final_incentive | number:'1.2-2' }}</td>
              <td>{{ ((entry.change_value || 0) - (entry.final_discount || 0) + (entry.final_incentive || 0)) | number:'1.2-2' }}</td>
              <td>{{ lineItemCgstAmount(entry) | number: '1.2-2' }}<span *ngIf="gstMatch() && vendorBranchGstType === 'REGISTER'">({{ entry.gst_percentage/2}}%)</span></td>
              <td>{{ lineItemSgstAmount(entry) | number: '1.2-2' }}<span *ngIf="gstMatch() && vendorBranchGstType === 'REGISTER'">({{ entry.gst_percentage/2}}%)</span></td>
              <td>{{ lineItemIgstAmount(entry) | number: '1.2-2' }}<span *ngIf="gstMatch() === false && vendorBranchGstType === 'REGISTER'">({{ entry.gst_percentage}}%)</span></td>
              <td>{{ lineItemTotalGstAmount(entry) | number: '1.2-2' }}</td>
            </tr>
          </tbody>
        </table>
        <div class="gst-total" style="display: flex; justify-content: flex-end; padding: 10px; font-weight: bold;">
          <span>Sub Total GST Amount: {{ getTotalGSTForDetails(sales_invoice_details) | number: '1.2-2' }}</span>
        </div>
        <mat-card>
          <mat-card-content>
            <mat-form-field>
              <mat-label>Enter Narration<span style="color: red">*</span></mat-label>
              <textarea matInput [(ngModel)]="narration" placeholder="Enter Narration" [disabled]="isView"></textarea>
            </mat-form-field>
          </mat-card-content>
        </mat-card>
        <mat-form-field>
          <input matInput type="file" [(ngModel)]="file" class="img" multiple (change)="onFileSelected($event)" [disabled]="isView">
          <div class="file-names-container">
            <div *ngFor="let selectedFile of myFiles; let i = index" class="file-name">
              {{ selectedFile.name }}
              <button mat-icon-button (click)="removeFile(i)" [disabled]="isView">
                <mat-icon>clear</mat-icon>
              </button>
            </div>
          </div>
          <br>
          <br>
          <p mat-button *ngIf="!isView && operationType !== 'create'" class="click-here" (click)="openVoucherFileShowModal()">
            Click Here for see uploaded filess</p>
        </mat-form-field>
        <br>
      </div>
      <div mat-dialog-actions>
        <button mat-button class="btn btn-primary" (click)="enterEditFromView()" *ngIf="isView && canEditFromView()">Edit</button>
        <button mat-button class="btn btn-danger" (click)="deleteVoucherFromView()" *ngIf="isView && canEditFromView()">Delete</button>
        <button mat-button class="btn btn-success" (click)="posting()" *ngIf="isView && showPostButton && is_posted != 1 && (approval_status == true || data.approval_status == 'Approved')">Post</button>
        <button mat-button class="btn btn-success" (click)="saveCreditNote()" *ngIf="!isView && type !== 'view'" [disabled]="data.approval_status === 'Pending' || data.approval_status === 'Approved'">{{ getButton()}}</button>
        <button mat-button class="btn btn-success" (click)="CreditNote()" *ngIf="!isView">View</button>
        <button mat-button class="btn btn-primary" (click)="convertToPdf()" *ngIf="!isView">Download pdf</button>
        <button mat-button class="btn btn-danger" mat-dialog-close>Cancel</button>
      </div>
    </mat-card-content>
  </mat-card>
  
  <mat-card *ngIf="this.voucher_type == 'Debit Note'&& this.invoice_type == 'purchase'">
    <mat-card-content>
      <div>
        <h5><b>List of Item/Service</b></h5>
      </div>
      <div>
        <table class="product-table">
          <thead>
            <tr>
              <th>Profit/Cost</th>
              <th>Section</th>
              <th>Item/Service Name</th>
              <th>HSN/SAC No</th>
              <th>Description</th>
              <th>UOM</th>
              <th>Unit Price</th>
              <th>Quantity</th>
              <th>Value</th>
              <th>GST %</th>
              <th>Pending Quantity</th>
              <th>Change Quantity</th>
              <th>Change Value</th>
              <th>CGST</th>
              <th>SGST</th>
              <th>IGST</th>
              <th>Total GST Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let entry of purchase_invoice_details; let i = index">
              <td>{{ entry?.profit_cost_name}}</td>
              <td>{{ entry?.section_name }}</td>
              <td>{{ entry?.name}}</td>
              <td>{{ entry?.hsn_no }}</td>
              <td>{{ entry?.description }}</td> 
              <td>{{ entry?.unit_name }}</td>
              <td>{{ entry?.unit_price | number:'1.2-2' }}</td>
              <td>{{ entry?.qty | number:'1.3-3'}}</td>
              <td>{{ entry?.qty * entry?.unit_price | number:'1.2-2' }}</td>
              <td>{{ entry?.gst_percentage | number:'1.2-2' }}</td>
              <td>{{ entry?.pending_qty | number:'1.3-3' }}</td>
              <td><mat-form-field appearance="outline" style="width: 100px;">
                  <input matInput type="number" [(ngModel)]="entry.change_qty"
                    (ngModelChange)="QtyChange(entry,entry.change_qty,entry.unit_price)" min="0.001" step="0.001"
                    [disabled]="type != 2 || isView" />
                </mat-form-field>
              </td>
              <td>
                <mat-form-field appearance="outline" style="width: 120px;">
                  <input matInput type="number" [(ngModel)]="entry.change_value"
                    (ngModelChange)="PriceChange(entry,entry.qty,entry.change_value)" min="0.01" step="0.01"
                    [disabled]="type != 1 || isView" />
                </mat-form-field>
              </td>
              <td>{{ lineItemCgstAmount(entry) | number: '1.2-2' }}<span *ngIf="gstMatch() && vendorBranchGstType === 'REGISTER'">({{ entry.gst_percentage/2}}%)</span></td>
              <td>{{ lineItemSgstAmount(entry) | number: '1.2-2' }}<span *ngIf="gstMatch() && vendorBranchGstType === 'REGISTER'">({{ entry.gst_percentage/2}}%)</span></td>
              <td>{{ lineItemIgstAmount(entry) | number: '1.2-2' }}<span *ngIf="gstMatch() === false && vendorBranchGstType === 'REGISTER'">({{ entry.gst_percentage}}%)</span></td>
              <td>{{ lineItemTotalGstAmount(entry) | number: '1.2-2' }}</td>
            </tr>
          </tbody>
        </table>
        <div class="gst-total" style="display: flex; justify-content: flex-end; padding: 10px; font-weight: bold;">
          <span>Sub Total GST Amount: {{ getTotalGSTForDetails(purchase_invoice_details) | number: '1.2-2' }}</span>
        </div>
        <mat-card>
          <mat-card-content>
            <mat-form-field>
              <mat-label>Enter Narration<span style="color: red">*</span></mat-label>
              <textarea matInput [(ngModel)]="narration" placeholder="Enter Narration" [disabled]="isView"></textarea>
            </mat-form-field>
          </mat-card-content>
        </mat-card>
        <mat-form-field>
          <input matInput type="file" [(ngModel)]="file" class="img" multiple (change)="onFileSelected($event)" [disabled]="isView">
          <div class="file-names-container">
            <div *ngFor="let selectedFile of myFiles; let i = index" class="file-name">
              {{ selectedFile.name }}
              <button mat-icon-button (click)="removeFile(i)" [disabled]="isView">
                <mat-icon>clear</mat-icon>
              </button>
            </div>
          </div>
          <br>
          <br>
          <p mat-button *ngIf="!isView && operationType !== 'create'" class="click-here" (click)="openVoucherFileShowModal()">
            Click Here for see uploaded filess</p>
        </mat-form-field>
        <br>
      </div>
      <div mat-dialog-actions>
        <button mat-button class="btn btn-primary" (click)="enterEditFromView()" *ngIf="isView && canEditFromView()">Edit</button>
        <button mat-button class="btn btn-danger" (click)="deleteVoucherFromView()" *ngIf="isView && canEditFromView()">Delete</button>
        <button mat-button class="btn btn-success" (click)="posting()" *ngIf="isView && showPostButton && is_posted != 1 && (approval_status == true || data.approval_status == 'Approved')">Post</button>
        <button mat-button class="btn btn-success" (click)="saveDebitNote()" *ngIf="!isView">{{ getButton() }}</button>
        <button mat-button class="btn btn-success" (click)="DebitNote()" *ngIf="!isView">View</button>
        <button mat-button class="btn btn-primary" (click)="convertToPdf()" *ngIf="!isView">Download pdf</button>
        <button mat-button class="btn btn-danger" mat-dialog-close>Cancel</button>
      </div>
    </mat-card-content>
  </mat-card>
  
  <mat-card *ngIf="this.voucher_type == 'Credit Note' && this.invoice_type == 'debit note'">
    <mat-card-content>
      <div>
        <h5><b>List of Item/Service</b></h5>
      </div>
      <div>
        <table class="product-table">
          <thead>
            <tr>
              <th>Profit/Cost</th>
              <th>Section</th>
              <th>Item/Service Name</th>
              <th>HSN/SAC No</th>
              <th>Description</th>
              <th>UOM</th>
              <th>Unit Price</th>
              <th>Quantity</th>
              <th>Value</th>    
              <th>GST %</th>
              <th>CGST</th>
              <th>SGST</th>
              <th>IGST</th>
              <th>Total GST Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let entry of debit_note_details; let i = index">
              <td>{{ entry?.profit_cost_name}}</td>
              <td>{{ entry?.section_name }}</td>
              <td>{{ entry?.name}}</td>
              <td>{{ entry?.hsn_no }}</td>
              <td>{{ entry?.description }}</td>
              <td>{{ entry?.unit_name }}</td>
              <td>{{ entry?.unit_price | number:'1.2-2' }}</td>
              <td>{{ entry?.qty | number:'1.3-3' }}</td>
              <td>{{ (entry?.qty * entry?.unit_price) | number:'1.2-2' }}</td>   
              <td>{{ entry?.gst_percentage | number:'1.2-2' }}</td>
              <td>{{ lineItemCgstAmount(entry) | number: '1.2-2' }}<span *ngIf="gstMatch() && vendorBranchGstType === 'REGISTER'">({{ entry.gst_percentage/2}}%)</span></td>
              <td>{{ lineItemSgstAmount(entry) | number: '1.2-2' }}<span *ngIf="gstMatch() && vendorBranchGstType === 'REGISTER'">({{ entry.gst_percentage/2}}%)</span></td>
              <td>{{ lineItemIgstAmount(entry) | number: '1.2-2' }}<span *ngIf="gstMatch() === false && vendorBranchGstType === 'REGISTER'">({{ entry.gst_percentage}}%)</span></td>
              <td>{{ lineItemTotalGstAmount(entry) | number: '1.2-2' }}</td>
            </tr>
          </tbody>
        </table>
        <div class="gst-total" style="display: flex; justify-content: flex-end; padding: 10px; font-weight: bold;">
          <span>Sub Total GST Amount: {{ getTotalGSTForDetails(debit_note_details) | number: '1.2-2' }}</span>
        </div>
        <mat-card>
          <mat-card-content>
            <mat-form-field>
              <mat-label>Enter Narration<span style="color: red">*</span></mat-label>
              <textarea matInput [(ngModel)]="narration" placeholder="Enter Narration" [disabled]="isView"></textarea>
            </mat-form-field>
          </mat-card-content>
        </mat-card>
        <mat-form-field>
          <input matInput type="file" [(ngModel)]="file" class="img" multiple (change)="onFileSelected($event)"[disabled]="isView">
          <div class="file-names-container">
            <div *ngFor="let selectedFile of myFiles; let i = index" class="file-name">
              {{ selectedFile.name }}
              <button mat-icon-button (click)="removeFile(i)" [disabled]="isView">
                <mat-icon>clear</mat-icon>
              </button>
            </div>
          </div>
          <br>
          <br>
          <p mat-button *ngIf="!isView && operationType !== 'create'" class="click-here" (click)="openVoucherFileShowModal()">
            Click Here for see uploaded filess</p>
        </mat-form-field>
        <br>
      </div>
      <div mat-dialog-actions>
        <button mat-button class="btn btn-primary" (click)="enterEditFromView()" *ngIf="isView && canEditFromView()">Edit</button>
        <button mat-button class="btn btn-danger" (click)="deleteVoucherFromView()" *ngIf="isView && canEditFromView()">Delete</button>
        <button mat-button class="btn btn-success" (click)="posting()" *ngIf="isView && showPostButton && is_posted != 1 && (approval_status == true || data.approval_status == 'Approved')">Post</button>
        <button mat-button class="btn btn-success" (click)="saveCreditNote()" *ngIf="!isView">{{ getButton() }}</button>
        <button mat-button class="btn btn-success" (click)="DebitNote()" *ngIf="!isView">View</button>
        <button mat-button class="btn btn-primary" (click)="convertToPdf()" *ngIf="!isView">Download pdf</button>
        <button mat-button class="btn btn-danger" mat-dialog-close>Cancel</button>
      </div>
    </mat-card-content>
  </mat-card>
  
  <mat-card *ngIf="this.voucher_type == 'Debit Note'&& this.invoice_type == 'credit note'">
    <mat-card-content>
      <div>
        <h5><b>List of Item/Service</b></h5>
      </div>
      <div>
        <table class="product-table">
          <thead>
            <tr>
              <th>Profit/Cost</th>
              <th>Section</th>
              <th>Item/Service Name</th>
              <th>HSN/SAC No</th>
              <th>Description</th>
              <th>UOM</th>
              <th>Unit Price</th>
              <th>Quantity</th>
              <th>Value</th>
              <th>Discount Amount</th>
              <th>Incentive Amount</th>
              <th>Final Value</th>
              <th>GST %</th>
              <th>CGST</th>
              <th>SGST</th>
              <th>IGST</th>
              <th>Total GST Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let entry of credit_note_details; let i = index">
              <td>{{ entry?.profit_cost_name}}</td>
              <td>{{ entry?.section_name }}</td>
              <td>{{ entry?.name}}</td>
              <td>{{ entry?.hsn_no }}</td>
              <td>{{ entry?.description }}</td>
              <td>{{ entry?.unit_name }}</td>
              <td>{{ entry?.unit_price | number:'1.2-2' }}</td>
              <td>{{ entry?.qty | number:'1.3-3' }}</td>
              <td>{{ entry?.qty * entry?.unit_price | number:'1.2-2' }}</td>
               <td>{{ entry?.discount_amount | number:'1.2-2' }}</td>
              <td>{{ entry?.incentive_amount | number:'1.2-2' }}</td>
              <td>{{ ((entry?.qty * entry?.unit_price) - (entry?.discount_amount || 0) + (entry?.incentive_amount || 0)) | number:'1.2-2' }}</td>
              <td>{{ entry?.gst_percentage | number:'1.2-2' }}</td>
              <td>{{ lineItemCgstAmount(entry) | number: '1.2-2' }}<span *ngIf="gstMatch() && vendorBranchGstType === 'REGISTER'">({{ entry.gst_percentage/2}}%)</span></td>
              <td>{{ lineItemSgstAmount(entry) | number: '1.2-2' }}<span *ngIf="gstMatch() && vendorBranchGstType === 'REGISTER'">({{ entry.gst_percentage/2}}%)</span></td>
              <td>{{ lineItemIgstAmount(entry) | number: '1.2-2' }}<span *ngIf="gstMatch() === false && vendorBranchGstType === 'REGISTER'">({{ entry.gst_percentage}}%)</span></td>
              <td>{{ lineItemTotalGstAmount(entry) | number: '1.2-2' }}</td>
            </tr>
          </tbody>
        </table>
        <div class="gst-total" style="display: flex; justify-content: flex-end; padding: 10px; font-weight: bold;">
          <span>Sub Total GST Amount: {{ getTotalGSTForDetails(credit_note_details) | number: '1.2-2' }}</span>
        </div>
        <mat-card>
          <mat-card-content>
            <mat-form-field>
              <mat-label>Enter Narration<span style="color: red">*</span></mat-label>
              <textarea matInput [(ngModel)]="narration" placeholder="Enter Narration" [disabled]="isView"></textarea>
            </mat-form-field>
          </mat-card-content>
        </mat-card>
        <mat-form-field>
          <input matInput type="file" [(ngModel)]="file" class="img" multiple (change)="onFileSelected($event)" [disabled]="isView">
          <div class="file-names-container">
            <div *ngFor="let selectedFile of myFiles; let i = index" class="file-name">
              {{ selectedFile.name }}
              <button mat-icon-button (click)="removeFile(i)" [disabled]="isView">
                <mat-icon>clear</mat-icon>
              </button>
            </div>
          </div>
          <br>
          <br>
          <p mat-button *ngIf="!isView && operationType !== 'create'" class="click-here" (click)="openVoucherFileShowModal()">
            Click Here for see uploaded filess</p>
        </mat-form-field>
        <br>
      </div>
      <div mat-dialog-actions>
        <button mat-button class="btn btn-primary" (click)="enterEditFromView()" *ngIf="isView && canEditFromView()">Edit</button>
        <button mat-button class="btn btn-danger" (click)="deleteVoucherFromView()" *ngIf="isView && canEditFromView()">Delete</button>
        <button mat-button class="btn btn-success" (click)="posting()" *ngIf="isView && showPostButton && is_posted != 1 && (approval_status == true || data.approval_status == 'Approved')">Post</button><button mat-button class="btn btn-success" (click)="saveDebitNote()" *ngIf="!isView">{{ getButton() }}</button>
        <button mat-button class="btn btn-success" (click)="CreditNote()" *ngIf="!isView">View</button>
        <button mat-button class="btn btn-primary" (click)="convertToPdf()" *ngIf="!isView">Download pdf</button>

        <button mat-button class="btn btn-primary" *ngIf="!isView && data.id && (data.approval_status == null || data.approval_status == 'Open' || data.approval_status == 'Rejected')" (click)="sendForApprove()">Send For Approval</button>
        <button mat-button class="btn btn-info" *ngIf="!isView && data.id && (data.approval_status == 'Pending' || data.approval_status == 'Rejected' || data.approval_status == 'Approved')"(click)="showApprovalTimeline()">
          <mat-icon>timeline</mat-icon>
          Approval Timeline
        </button>
        <button mat-button class="btn btn-danger" mat-dialog-close>Cancel</button>
      </div>
    </mat-card-content>
  </mat-card>
</div>